import { render, staticRenderFns } from "./outcome.vue?vue&type=template&id=c15264f6&scoped=true&"
import script from "./outcome.vue?vue&type=script&lang=js&"
export * from "./outcome.vue?vue&type=script&lang=js&"
import style0 from "./outcome.vue?vue&type=style&index=0&id=c15264f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15264f6",
  null
  
)

export default component.exports